import React, { useCallback, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { connectAutoComplete, SearchBox } from "react-instantsearch-dom";
import { injectIntl } from "react-intl";
import "./SearchAutocomplete.scss";
import SearchResults from "app/pages/Faq/SearchAutocomplete/SearchResults";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import AppGlobalsContext from "app/AppGlobalsContext";

const SearchAutocomplete = ({ hits, currentRefinement, refine, intl }) => {
	const { resolution } = useContext(AppGlobalsContext);

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	const handleResultClick = useCallback(() => {
		refine();
	}, []);

	useEffect(() => {
		if (isMobile) {
			const home = document.querySelector(".faq-home");
			const main = document.querySelector(".faq__main");

			if (currentRefinement) {
				if (home) {
					home.style.display = "none";
				}
				if (main) {
					main.style.display = "none";
				}
			} else {
				if (home) {
					home.style.display = "block";
				}
				if (main) {
					main.style.display = "block";
				}
			}
		}
	}, [currentRefinement, isMobile]);

	return (
		<div className="search-autocomplete">
			<div className="search-autocomplete__input">
				<SearchBox
					showLoadingIndicator
					translations={{
						placeholder: intl.formatMessage({ id: "faq.search.placeholder" }),
					}}
				/>
			</div>
			{currentRefinement && (
				<div className="search-autocomplete__results">
					<SearchResults hits={hits} onResultClick={handleResultClick} />
				</div>
			)}
		</div>
	);
};

SearchAutocomplete.propTypes = {
	intl: PropTypes.object,
	hits: PropTypes.array,
	currentRefinement: PropTypes.string,
	refine: PropTypes.func,
};

export default connectAutoComplete(injectIntl(SearchAutocomplete));
